import React from 'react';
import {
  Box,
  Button,
  Paper,
  Typography,
  makeStyles,
} from '@material-ui/core';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

import GenericTemplate from '../components/templates/GenericTemplate';
import { xrViewerAuthoringToolUrl } from '../xross.config.js';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gap: theme.spacing(2),
  },
  iframe: {
    width: '100%',
    height: '80vh',
    border: 0,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: '#fff',
  },
  message: {
    padding: theme.spacing(3),
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));

const XRViewerAuthoringPage: React.FC = () => {
  const classes = useStyles();
  const toolUrl = xrViewerAuthoringToolUrl?.trim();

  return (
    <GenericTemplate title="XRViewer オーサリングツール">
      <Box className={classes.root}>
        {!toolUrl ? (
          <Paper variant="outlined" className={classes.message}>
            <Typography variant="h6" gutterBottom>
              XRViewer オーサリングツールの URL が未設定です
            </Typography>
            <Typography variant="body1">
              {'src/xross.config.js'} の {'xrViewerAuthoringToolUrl'} を設定すると、
              moon 管理画面内に埋め込み表示できます。
            </Typography>
          </Paper>
        ) : (
          <>
            <Box className={classes.actions}>
              <Button
                variant="outlined"
                color="primary"
                href={toolUrl}
                target="_blank"
                rel="noopener noreferrer"
                startIcon={<OpenInNewIcon />}
              >
                別タブで開く
              </Button>
            </Box>

            <Paper variant="outlined">
              <iframe
                title="XRViewer authoring tool"
                src={toolUrl}
                className={classes.iframe}
              />
            </Paper>

            <Typography variant="body2" color="textSecondary">
              埋め込み先の設定によっては、X-Frame-Options や Content-Security-Policy により iframe 表示できない場合があります。その場合は上のボタンから別タブで開いてください。
            </Typography>
          </>
        )}
      </Box>
    </GenericTemplate>
  );
};

export default XRViewerAuthoringPage;
